/** Adds https:// when the user omits a scheme (http:// or https://). */
export function ensureHttpUrlPrefix(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export function isValidHttpUrl(value: string): boolean {
  const normalized = ensureHttpUrlPrefix(value);
  if (!normalized) return false;
  try {
    const url = new URL(normalized);
    return Boolean(url.hostname);
  } catch {
    return false;
  }
}
